import { Injectable, computed, signal } from '@angular/core';
import { AuthService } from '../components/default/login/service/login-service/auth.service';
import { Permission, UserRole, MenuItem, ROLE_PERMISSIONS, MENU_ITEMS } from '../models/permission.model';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private userPermissions = signal<Permission[]>([]);

  constructor(private authService: AuthService) {
    // Update permissions when user changes
    this.updatePermissions();
  }

  private updatePermissions(): void {
    const user = this.authService.user();
    if (user && user.role) {
      this.userPermissions.set(ROLE_PERMISSIONS[user.role] || []);
    } else {
      this.userPermissions.set([]);
    }
  }

  hasPermission(permission: Permission): boolean {
    return this.userPermissions().includes(permission);
  }

  hasAnyPermission(permissions: Permission[]): boolean {
    return permissions.some(permission => this.hasPermission(permission));
  }

  hasAllPermissions(permissions: Permission[]): boolean {
    return permissions.every(permission => this.hasPermission(permission));
  }

  getFilteredMenuItems(): MenuItem[] {
    return MENU_ITEMS.filter(item => 
      this.hasAnyPermission(item.permissions)
    );
  }

  getRole(): UserRole | null {
    return this.authService.user()?.role || null;
  }
}

